
//
const createElement = require('../utils/createElement.js');

//
const captchaProtectedForms = document.querySelectorAll('form[data-captcha-site-key]');

//if there any forms wanting a captcha - then load the js
if (captchaProtectedForms != null && captchaProtectedForms.length > 0) {

    //start loading the captcha api
    const captchaScript = createElement('script', {'src' : 'https://www.google.com/recaptcha/api.js?onload=ongReCaptchaLoaded&render=explicit', 'async' : 'async', 'defer' : 'defer' });
    document.querySelector('head').append(captchaScript);

    //lets disable the buttons on the forms until the captcha is collected
    for (const captchaProtectedForm of captchaProtectedForms) {
        captchaProtectedForm.querySelector('button:not([type="button"])').setAttribute('disabled', 'disabled');
    }

    //
    window.ongReCaptchaLoaded = function() {

        //
        for (const captchaProtectedForm of captchaProtectedForms) {

            //render the captcha element so we can get the user to press it
            const grecaptchaContainer = createElement('div', {'class' : 'form-captcha'});

            //
            if (typeof captchaProtectedForm.dataset.captchaHidden !== 'undefined') {
                grecaptchaContainer.classList.add('hidden');
                captchaProtectedForm.addEventListener('input', function(event) {
                    grecaptchaContainer.classList.remove('hidden');
                });
            }

            //
            captchaProtectedForm.querySelector('.form-controls').prepend(grecaptchaContainer);

            //
            grecaptcha.render(grecaptchaContainer, {
                'sitekey' : captchaProtectedForm.dataset.captchaSiteKey,
                'callback' : function(response) {

                    //
                    captchaProtectedForm.appendChild(createElement('input', {'type' : 'hidden', 'name' : 'captchaToken', 'value' : response }));

                    //
                    captchaProtectedForm.querySelector('button:not([type="button"])').removeAttribute('disabled');

                }
            });

        }
    };

}